/** Định dạng số tiền VND hiển thị báo cáo Shopee. */
export function formatVnd(value) {
  if (value == null || value === '') return '—';
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  return `${new Intl.NumberFormat('vi-VN').format(Math.round(n))}₫`;
}

/** Tỉ lệ từ API (thường 0–1 hoặc phần trăm đã nhân). */
export function formatRatioDisplay(ratio) {
  if (ratio == null || typeof ratio !== 'number' || Number.isNaN(ratio)) return '—';
  const asPct = ratio <= 1 && ratio >= 0 ? ratio * 100 : ratio;
  return `${Number(asPct.toFixed(2))}%`;
}

export function isoDateMinusDays(days) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

export function isoToday() {
  return new Date().toISOString().slice(0, 10);
}
